import { hooks, mui, React } from '_core';

const BenchmarkNeutralView = ({ benchmarkNeutral }: { benchmarkNeutral: boolean }) => {
  const uiStyles = hooks.useUiStyles();
  return <>{benchmarkNeutral && <mui.core.Chip label="Benchmark Relative" sx={uiStyles.sectionHandle} />}</>;
};

export default BenchmarkNeutralView;
